var map = {
	"./2co.png": "a418",
	"./alipay.png": "418a",
	"./alipay2.png": "a923",
	"./amazon.png": "6826",
	"./american_express.png": "e886",
	"./american_express_black.png": "27b8",
	"./american_express_gold.png": "d756",
	"./american_express_green.png": "5443",
	"./american_express_platinum.png": "30ee",
	"./asia_pay.png": "53b9",
	"./asia_pay2.png": "eb4b",
	"./bank_of_america.png": "6379",
	"./cash.png": "fd30",
	"./cashu.png": "581c",
	"./chase.png": "a7f8",
	"./check.png": "0296",
	"./china_union.png": "ff16",
	"./cirrus.png": "9bc6",
	"./cirrus2.png": "4a1b",
	"./citybank.png": "08c8",
	"./clickandbuy.png": "01eb",
	"./credit_card.png": "11fe",
	"./credit_cards.png": "9f38",
	"./currency_baht_sign.png": "eb8e",
	"./currency_bitcoin_sign.png": "cec6",
	"./currency_denar_sign.png": "23d1",
	"./currency_dinar_sign.png": "9573",
	"./currency_dollar_sign.png": "38fe",
	"./currency_dollar_sign2.png": "de1b",
	"./currency_euro_sign.png": "c4ab",
	"./currency_peso_sign.png": "54e5",
	"./currency_pound_sign.png": "3b77",
	"./currency_rial_sign.png": "cffb",
	"./currency_ruble_sign.png": "77b0",
	"./currency_rupee_sign.png": "7838",
	"./currency_sign.png": "9e09",
	"./currency_yen_sign.png": "4824",
	"./currency_yen_sign2.png": "cbe8",
	"./currency_yuan_sign.png": "05da",
	"./diners_club.png": "3b8d",
	"./discover.png": "730e",
	"./e_check.png": "86cd",
	"./electroncash.png": "bf9e",
	"./eps.png": "0cbb",
	"./gift_card.png": "cabb",
	"./giropay.png": "e534",
	"./google_wallet.png": "4517",
	"./jcb.png": "ad2e",
	"./maestro.png": "bc9b",
	"./maestro2.png": "7464",
	"./mastercard.png": "8d4fe",
	"./mastercard2.png": "5a68",
	"./mastercard_gold.png": "114c",
	"./mastercard_platinum.png": "c466",
	"./obopay.png": "5718",
	"./paymate.png": "c830",
	"./paymate2.png": "acc6",
	"./paypal.png": "2cab",
	"./purchase_order.png": "4bb8",
	"./skrill.png": "8ef9",
	"./transferwise.png": "4268",
	"./ukash.png": "c889",
	"./visa.png": "0043",
	"./visa_electron.png": "5aad",
	"./visa_gold.png": "37d2",
	"./visa_platinum.png": "4a5c",
	"./webmoney.png": "c708",
	"./western_union.png": "8f41",
	"./wire_transfer.png": "5d8a",
	"./worldpay.png": "2375",
	"./xoom.png": "d8e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b855";